import { NavLink } from 'react-router-dom';
import type { User } from '@clan-heart/shared';
import { canManage } from '@clan-heart/shared';
import { RoleBadge } from './RoleBadge.js';
import { Button } from './Button.js';
import styles from './Header.module.css';

interface HeaderProps {
  me: User;
  pendingCount: number | undefined;
  pendingRecruitsCount: number | undefined;
  onSignOut: () => void;
}

function navLinkClass({ isActive }: { isActive: boolean }): string {
  return isActive ? `${styles.navLink} ${styles.navLinkActive}` : (styles.navLink ?? '');
}

export function Header({ me, pendingCount, pendingRecruitsCount, onSignOut }: HeaderProps) {
  const manages = canManage(me.role);
  return (
    <header className={styles.header}>
      <nav className={styles.nav} aria-label="Main">
        <NavLink to="/cave" className={navLinkClass} end>
          Accomplishments
        </NavLink>
        <NavLink to="/cave/leaderboard" className={navLinkClass}>
          Leaderboard
        </NavLink>
        <NavLink to="/cave/claims" className={navLinkClass}>
          My claims
        </NavLink>
        <NavLink to="/cave/profile" className={navLinkClass}>
          My profile
        </NavLink>
        {manages && (
          <NavLink to="/cave/review" className={navLinkClass}>
            Review
            {!!pendingCount && pendingCount > 0 && (
              <span className={styles.badge}>{pendingCount}</span>
            )}
          </NavLink>
        )}
        {manages && (
          <NavLink to="/cave/manage" className={navLinkClass}>
            Manage
          </NavLink>
        )}
        {manages && (
          <NavLink to="/cave/crew" className={navLinkClass}>
            Crew
            {!!pendingRecruitsCount && pendingRecruitsCount > 0 && (
              <span className={styles.badge}>{pendingRecruitsCount}</span>
            )}
          </NavLink>
        )}
        {manages && (
          <NavLink to="/cave/ships" className={navLinkClass}>
            Ships
          </NavLink>
        )}
      </nav>
      <div className={styles.profile}>
        {me.avatarUrl ? (
          <img className={styles.avatar} src={me.avatarUrl} alt="" />
        ) : (
          <span className={styles.avatarFallback} aria-hidden="true">
            {me.crewName.slice(0, 1).toUpperCase()}
          </span>
        )}
        <span className={styles.name}>{me.crewName}</span>
        <RoleBadge role={me.role} />
        <Button type="button" variant="ghost" onClick={onSignOut}>
          Sign out
        </Button>
      </div>
    </header>
  );
}
